import { ApolloClient, InMemoryCache, split, ApolloProvider } from '@apollo/client';
import { HttpLink } from '@apollo/client/link/http';
import { getMainDefinition } from '@apollo/client/utilities';
console.log(process.env.REACT_APP_GRAPHQL_SERVER_URI);


// 创建 HTTP link
const httpLink = new HttpLink({
  uri: process.env.REACT_APP_GRAPHQL_SERVER_URI,
});

// // 创建 WebSocket link
// const wsLink = new WebSocketLink({
//   uri: process.env.REACT_APP_GRAPHQL_WS_URI,
//   options: {
//     reconnect: false,
//   },
// });

// 通过 split 确定请求类型
const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition'
      // &&
      // definition.operation === 'subscription'
    );
  },
  // wsLink,
  httpLink
);

const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});

const ApolloApp = ({ children }) => (
  <ApolloProvider client={client}>
    {children}
  </ApolloProvider>
);

export default ApolloApp;
